import LTR from "@brand-icons/global/tools-no_tool/tools-no_tool-ltr.svg";

import { iconFactory } from "../iconFactory";

export const ToolsNoToolIcon = iconFactory("ToolsNoToolIcon", LTR);
